<template>
  <div :class="['stat-block', `stat-block--${variant}`]">
    <div class="stat-block__value">
      <slot name="value">
        {{ value }}
      </slot>
    </div>
    <div class="stat-block__label">
      <slot name="label">
        {{ label }}
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  value?: string;
  label?: string;
  variant?: "default" | "large" | "compact";
}

withDefaults(defineProps<Props>(), {
  value: undefined,
  label: undefined,
  variant: "default",
});
</script>

<style scoped lang="scss">
@use "../styles/abstracts/breakpoints" as *;

.stat-block {
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);
  text-align: center;
}

.stat-block__value {
  font-family: var(--font-family-heading);
  font-weight: var(--font-weight-bold);
  /* Matches real headings and adapts per theme. */
  color: var(--color-text-heading);
  line-height: 1;
}

.stat-block__label {
  color: var(--color-text-muted);
  font-weight: var(--font-weight-medium);
}

/* Default size */
.stat-block--default .stat-block__value {
  font-size: var(--font-size-3xl);

  @include lg {
    font-size: var(--font-size-4xl);
  }
}

.stat-block--default .stat-block__label {
  font-size: var(--font-size-base);
}

/* Large variant */
.stat-block--large .stat-block__value {
  font-size: var(--font-size-4xl);

  @include lg {
    font-size: var(--font-size-6xl);
  }
}

.stat-block--large .stat-block__label {
  font-size: var(--font-size-lg);
}

/* Compact variant */
.stat-block--compact .stat-block__value {
  font-size: var(--font-size-2xl);
}

.stat-block--compact .stat-block__label {
  font-size: var(--font-size-sm);
}
</style>
